import { useState, useRef, useEffect } from "react";
import Slider from "react-slick";

export default function ProdunitShowroom() {
    const sliderRef = useRef(null);

    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => { 
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);


    
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        cssEase: "ease",
        responsive: [
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2 },
        },
        ],
    };

  return (
    <>
    <section className="detailserv-style produnit-showroom">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <h4>Showroom Presence</h4>
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Our Location</span>
                    </div>
                </div>

                <div className="col-lg-12">
                    <Slider {...settings} ref={sliderRef} className="showroom-slider">
                        <div>
                            <div className="showroombox">
                                <img src="/image/showroom-1.webp" loading="lazy" className="img-responsive" alt="Showroom"/>
                                <div>
                                    <img src="/image/locate-icon.webp" loading="lazy" alt="map"/>
                                    <span>Bahadurgarh Showroom</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="showroombox">
                                <img src="/image/showroom-2.webp" loading="lazy" className="img-responsive" alt="Showroom"/>
                                <div>
                                    <img src="/image/locate-icon.webp" loading="lazy" alt="map"/>
                                    <span>Gurgaon Showroom</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="showroombox">
                                <img src="/image/showroom-3.webp" loading="lazy" className="img-responsive" alt="Showroom"/>
                                <div>
                                    <img src="/image/locate-icon.webp" loading="lazy" alt="map"/>
                                    <span>Sonipat Showroom</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="showroombox">
                                <img src="/image/showroom-4.webp" loading="lazy" className="img-responsive" alt="Showroom"/>
                                <div>
                                    <img src="/image/locate-icon.webp" loading="lazy" alt="map"/>
                                    <span>Panipat Showroom</span>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>

            </div>
        </div>
    </section>             
    </>
  )
}
